import { useContext } from 'react';

import { Feature } from 'config/features';
import { popupParams } from 'config/Popup/params';

import { useFeature } from 'hooks/useFeature';
import { useLinkTarget } from 'hooks/useLinkTarget';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

export const useFallbackUrl = () => {
    const isHibOnPageActive = useFeature(Feature.HibOnPage);
    const linkTarget = useLinkTarget();
    const { components } = useContext(CommunicationContext);
    const { backendInformationFunc } = components;
    const topLevelDomain = backendInformationFunc?.getToplevelDomain() || 'de';
    const helpUrl = `https://check24.${topLevelDomain}/unternehmen/kontakt/?sec=rsn`;

    return () => {
        if (isHibOnPageActive) {
            window.open(helpUrl, linkTarget);
        } else {
            const params = popupParams.contact;
            try {
                const windowOpen = window.open(
                    helpUrl,
                    params.title,
                    `width=${params.width},height=${params.height},scrollbars=yes`
                );
                if (!!windowOpen) {
                    try {
                        windowOpen.focus();
                    } catch (error) {
                        throw new Error(
                            `Error window.open not allowed: ${error}`
                        );
                    }
                }
            } catch (error) {
                throw new Error(`Error opening contact popup: ${error}`);
            }
        }
    };
};
